<script lang='ts'>
	import { onMount } from 'svelte'

    import { getCookiekey, getCookieValue, setCookieValue } from '$lib/cookies'
	import { getSettingsValue } from '$lib/stores/bo_settings'

	export let name = ''

	let devWarning = true
	let closed_by_user = false
	let note_config = {visible:false, cookie:'', title:'', text:''}

	onMount(()=>{
		if(name!='') {
			const configStr = getSettingsValue(name)
			note_config = JSON.parse(configStr)

			const notifCookieName = getNotifCookieName()
			const notifCookieValue = getCookieValue(notifCookieName)
			if (notifCookieValue)
				closed_by_user = true
		}
	})

	function handleClose()
	{
		const notifCookieName = getNotifCookieName()
		setCookieValue(notifCookieName, '1', 10)
		devWarning = false
	}

	function getNotifCookieName() : string
	{
		const notifCookieName = getCookiekey('inv-notif') + '_' + name + '_' + note_config.cookie
		return notifCookieName
	}
</script>
{#if note_config.visible && devWarning && !closed_by_user}
	<div class="bg-blue-100 border border-blue-400 px-4 py-3 mb-5 rounded relative" role="alert">
		<div><strong class="font-bold">{note_config.title}</strong></div>
		<span class="block sm:inline">{note_config.text}</span>
		<span class="absolute top-0 bottom-0 right-0 px-4 py-3"
			on:click={handleClose}
			on:keydown={handleClose}
		>
			<svg class="fill-current h-6 w-6 text-blue-500 hover:text-blue-800" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"></path></svg>
		</span>
	</div>
{/if}
